import React, { useState, useEffect } from "react";
import "./styles/CounterSection.css";

const CounterSection = () => {
  const [satisfiedClients, setSatisfiedClients] = useState(0);
  const [clientReferrals, setClientReferrals] = useState(0);
  const [awardRecognitions, setAwardRecognitions] = useState(0);
  const [sampleHeadline, setSampleHeadline] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (satisfiedClients < 35) setSatisfiedClients(satisfiedClients + 1);
      if (clientReferrals < 15514) setClientReferrals(clientReferrals + 100);
      if (awardRecognitions < 700) setAwardRecognitions(awardRecognitions + 1);
      if (sampleHeadline < 0) setSampleHeadline(sampleHeadline + 10);
    }, 50);

    return () => clearInterval(interval);
  }, [satisfiedClients, clientReferrals, awardRecognitions, sampleHeadline]);

  return (
    <section className="counter-feature-section">
      <div className="counter-section-container">
        <h1 className="counter-title">Numbers Don’t Lie</h1>
        <div className="counter-section">
          <div className="counter-item">
            <h2>{satisfiedClients}</h2>
            <p>Universities Profiles</p>
          </div>
          <div className="counter-item">
            <h2>{clientReferrals}+</h2>
            <p>Faculty Profiles</p>
          </div>
          <div className="counter-item">
            <h2>{awardRecognitions}+</h2>
            <p>Private Tutors</p>
          </div>
          <div className="counter-item">
            <h2>{sampleHeadline}</h2>
            <p>Study Materials</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CounterSection;
